import { useState, useEffect, useRef } from 'react'
import { motion, useScroll, useSpring, useInView, useMotionValueEvent } from 'motion/react'
import styles from './A23Home.module.css'
import gameAssets from '@themed-assets'
import useHomePageUtils from '../../../hooks/utils/useHomepageUtils'
import { useChannel, useAccessToken, useMasterGameDefinitions } from '../../../hooks/data/useLobby'
import { useNavigate } from 'react-router'
import HomeHeader from '../../../components/HomeHeader/HomeHeader'
import HomeFooter from '../../../components/HomeFooter/HomeFooter'
import useHomePageData from '@/src/hooks/utils/useHomePageData'

// Move Section component outside to prevent re-creation on every render
const Section = ({ children, className }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: "-20%",
    amount: 0.3, // Only trigger when 30% of the element is in view
  });

  return (
    <motion.section
      ref={ref}
      className={className}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={{
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0 },
      }}
      transition={{ duration: 0.5, ease: "easeOut" }}
    >
      {children}
    </motion.section>
  );
};

function A23Home() {
  const navigate = useNavigate();
  const [isHeaderVisible, setIsHeaderVisible] = useState(true)
  const [isFooterVisible, setIsFooterVisible] = useState(true)
  const channel = useChannel();
  const accessToken = useAccessToken();
  const masterGameDefinitions = useMasterGameDefinitions();
  const { scrollY } = useScroll()
  const lastScrollY = useRef(0)
  // const { fetchHomePageData } = useHomePageUtils();
  useHomePageData();

  // Throttle scroll updates
  useMotionValueEvent(scrollY, "change", (latest) => {
    // Only update if the scroll difference is significant (more than 10px)
    if (Math.abs(latest - lastScrollY.current) < 10) return;

    const scrollingUp = latest < lastScrollY.current;
    const isAtTop = latest < 50;

    requestAnimationFrame(() => {
      setIsHeaderVisible(scrollingUp || isAtTop);
      setIsFooterVisible(scrollingUp || isAtTop);
      lastScrollY.current = latest;
    });
  });

  // useEffect(() => {
  //     if (channel && accessToken && Object.keys(masterGameDefinitions).length > 0) {
  //         // fetchHomePageData();
  //     }
  // }, [masterGameDefinitions, channel, accessToken])

  return (
    <div className={styles.homeContainer}>
      <HomeHeader isVisible={isHeaderVisible} />

      <div className={styles.homeBanner}>
        <img style={{ width: "100%" }} src={gameAssets.homeBanner}></img>
      </div>

      <main className={styles.homeContent}>
        <Section className={styles.heroSection}>
          <div className={styles.homeGrid}>
            <div
              onClick={() => navigate("/cashLobby")}
              className={styles.homeGridItem}
            >
              <img
                className={styles.homeGridItemImg}
                src={gameAssets.gridCash}
              ></img>
            </div>
            <div
              onClick={() => navigate("/tourneyLobby")}
              className={styles.homeGridItem}
            >
              <img
                className={styles.homeGridItemImg}
                src={gameAssets.gridTourney}
              ></img>
            </div>
            <div className={styles.homeGridItem}>
              <img
                className={styles.homeGridItemImg}
                src={gameAssets.gridFreeRoll}
              ></img>
            </div>
            <div className={styles.homeGridItem}>
              <img
                className={styles.homeGridItemImg}
                src={gameAssets.gridPractice}
              ></img>
            </div>
            <div onClick={() => navigate("/stats")} className={styles.myStats}>
							<div>My Stats</div>
						</div>
          </div>
        </Section>
      </main>
      <HomeFooter isVisible={isFooterVisible} />
    </div>
  )
}

export default A23Home;
